'use client';

import React from 'react';

export const FreestarPrivacyManager: React.FC = () => (
  <div className="freestar-privacy-manager">
    <style>{`
      #pmLink {
        visibility: hidden;
        text-decoration: none;
        cursor: pointer;
        background: transparent;
        border: none;
        padding: 0;
        margin: 0;
        font: inherit;
        color: inherit;
      }
      #pmLink:hover {
        visibility: visible;
        color: grey;
      }
      .freestar-privacy-manager {
        font-size: 0.9rem;
        line-height: 1.4;
        color: #b3b3b3;
      }
    `}</style>
    <button id="pmLink" type="button">
      Privacy Manager
    </button>
  </div>
);
